var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.33,
    height: 21.33,
    viewBox: "0 0 21.33 21.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1803.67 -960)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1795 951.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,8.67H10.67a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10.67A2,2,0,0,0,28,8.67ZM24.67,20.33H20.33v4.34a1,1,0,0,1-2,0V20.33H14a1,1,0,0,1-.9-1.43l.47-.47a1,1,0,0,1,.43-.1h4.33V14a1,1,0,0,1,.1-.43l.47-.47a1,1,0,0,1,1.43.9v4.33h4.34a1,1,0,0,1,0,2Z",
    fill: "#1f2e3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.8378348b2472aa3c3f82fc7a8f915b5b.svg";
export { ForwardRef as ReactComponent };